import { Session } from 'next-auth';

const useMakeUserImageWithNonce = (session: Session | null) => {
    if (session?.user?.image && session?.expires) return `${session.user?.image}?nonce=${session.expires}`;
    return '';
};
export { useMakeUserImageWithNonce };
